import generateQueryParams from '@/utils/generateQueryParams';
import axiosInstance from '@/plugins/api/axiosInstance';

export default function city() {
    const appUrl = import.meta.env.VITE_APP_URL;

    return {
        index,
        companySearch,
        get,
        create,
        update,
        remove,
        publicSearch
    };

    function index(options = {}) {
        const defaultValues = {
            pattern: '',
            limit: 25,
            page: 1
        };
        const params = generateQueryParams(options, defaultValues);
        return axiosInstance.get(`city/search${params}`);
    }

    function companySearch(options = {}) {
        const defaultValues = {
            pattern: '',
            limit: 25,
            page: 1
        };
        const params = generateQueryParams(options, defaultValues);
        return axiosInstance.get(`city/company-cities${params}`);
    }

    function get(id) {
        return axiosInstance.get(`city/get?id=${id}`);
    }

    function create(data) {
        return axiosInstance.post('city/create', data);
    }

    function update(data) {
        return axiosInstance.patch('city/update', data);
    }

    function remove(id) {
        return axiosInstance.delete(`city/delete`, {
            data: {
                id: id
            }
        });
    }

    function publicSearch(options = {}) {
        const defaultValues = {
            company: '',
            pattern: '',
            limit: 25,
            page: 1
        };
        const params = generateQueryParams(options, defaultValues);
        let url = `${appUrl}/public/cities${params}`;
        return axiosInstance.get(url);
    }
}
